import { usePresenter } from "../../deck/context";
import { joinHost } from "../../deck/JoinCard";
import { RehearsalTimer } from "./RehearsalTimer";

export function TopBar() {
  const { model, joinUrl, code, live, preview } = usePresenter();
  return (
    <div className="topbar">
      <span>{model.deck.title}</span>
      {preview ? (
        <span className="topbar-join">
          {joinHost(joinUrl)} <b className="code-chip">----</b>
        </span>
      ) : live?.ended ? (
        <span className="topbar-join">Session ended</span>
      ) : live ? (
        <span className="topbar-join">
          {!live.connected && <span className="topbar-status">Reconnecting · </span>}
          {joinHost(joinUrl)} <b className="code-chip">{code ?? "----"}</b>
        </span>
      ) : (
        <RehearsalTimer />
      )}
    </div>
  );
}
